import type { CallToActionModel } from '~/models'

export const useCtaTarget = (cta: CallToActionModel) => {
  return cta.elements.linkedTarget.value.length > 0 ? '_self' : '_blank';
}
